/**
 * Map Controls Store - Manages map control states (add pole mode, show ONUs, etc.)
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface MapControlsState {
  addPoleMode: boolean;
  showONUs: boolean;
  showVirtualPoles: boolean;
  /** farebný prstenec so stavom signálu na zákazníckych splittroch */
  showSignal: boolean;
  addCableByClickMode: boolean;
  deleteCableMode: boolean;
  toggleAddPoleMode: () => void;
  setAddPoleMode: (enabled: boolean) => void;
  toggleShowONUs: () => void;
  setShowONUs: (show: boolean) => void;
  toggleShowVirtualPoles: () => void;
  toggleShowSignal: () => void;
  setShowVirtualPoles: (show: boolean) => void;
  toggleAddCableByClickMode: () => void;
  setAddCableByClickMode: (enabled: boolean) => void;
  toggleDeleteCableMode: () => void;
  setDeleteCableMode: (enabled: boolean) => void;
}

export const useMapControlsStore = create<MapControlsState>()(
  persist(
    (set) => ({
      addPoleMode: false,
      showONUs: true,
      showVirtualPoles: false,
      showSignal: true,
      addCableByClickMode: false,
      deleteCableMode: false,

      toggleAddPoleMode: () => {
        set((state) => ({ addPoleMode: !state.addPoleMode }));
      },

      setAddPoleMode: (enabled: boolean) => {
        set({ addPoleMode: enabled });
      },

      toggleShowONUs: () => {
        set((state) => ({ showONUs: !state.showONUs }));
      },

      setShowONUs: (show: boolean) => {
        set({ showONUs: show });
      },

      toggleShowVirtualPoles: () => {
        set((state) => ({ showVirtualPoles: !state.showVirtualPoles }));
      },

      toggleShowSignal: () => {
        set((state) => ({ showSignal: !state.showSignal }));
      },

      setShowVirtualPoles: (show: boolean) => {
        set({ showVirtualPoles: show });
      },

      toggleAddCableByClickMode: () => {
        set((state) => ({
          addCableByClickMode: !state.addCableByClickMode,
          // Disable add pole mode and delete cable mode when enabling cable mode
          addPoleMode: state.addCableByClickMode ? state.addPoleMode : false,
          deleteCableMode: false
        }));
      },

      setAddCableByClickMode: (enabled: boolean) => {
        set((state) => ({
          addCableByClickMode: enabled,
          // Disable add pole mode and delete cable mode when enabling cable mode
          addPoleMode: enabled ? false : state.addPoleMode,
          deleteCableMode: false
        }));
      },

      toggleDeleteCableMode: () => {
        set((state) => ({
          deleteCableMode: !state.deleteCableMode,
          // Disable other modes when enabling delete cable mode
          addPoleMode: state.deleteCableMode ? state.addPoleMode : false,
          addCableByClickMode: false
        }));
      },

      setDeleteCableMode: (enabled: boolean) => {
        set((state) => ({
          deleteCableMode: enabled,
          // Disable other modes when enabling delete cable mode
          addPoleMode: enabled ? false : state.addPoleMode,
          addCableByClickMode: false
        }));
      },
    }),
    {
      name: 'map-controls-storage',
    }
  )
);

